<template>
  <div>
    <a
      class="db-100 tag-listing-filters-tag-entry-link"
      :href="`${builtQueryString}#list-page-start`"
      :title="entryDisplayValue(group, entry)"
      @click="isChecked = !isChecked"
    >
        <label
          v-if="group.tagDisplayType !== 'hex-color'"
          class="d-flex-100 pos-rel align-items-center align-content-center tag-listing-filters-tag-entry-name"
          :class="{
            'checked': isChecked || isFilterUsed(group, entry)
          }"
        >
          {{ entryDisplayValue(group, entry, { trim: true }) }}
        </label>
    </a>
  </div>
</template>

<script>

import TagListingFiltersMixin from '../Mixins/TagListingFiltersMixin'

export default {
  name: 'EntryFilter',
  mixins: [TagListingFiltersMixin],
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    entry: {
      tagDisplayValue: '',
      tagId: '',
      tagName: '',
      tagOrder: '',
      tagAllSlug: ''
    }
  },
  data() {
    return {
      isChecked: false
    }
  },
  computed: {
    builtQueryString () {
      return this.filteringManage(this.group, this.entry)
    }
  }
}
</script>

<style lang="scss" scoped>

.tag-listing-filters-tag-entry-link {
  font-size: 14px;
  margin-bottom:10px;
  display: flex;
  flex-wrap: wrap;
  height:100%
}

.tag-listing-filters-tag-entry-name {
  color: #231F20;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;
  padding: 0 0 0 25px;
  font-size: 14px;
  cursor: pointer;
  display:flex;
  min-height:20px;
  align-content:center;
  &::before {
    background-color: #fff;
    border: 1px solid #231f20;
    border-radius: unset;
    content: "";
    height: 20px;
    left: 0;
    position: absolute;
    right: auto;
    top: 4px;
    transition: all .28s cubic-bezier(.4,0,.2,1);
    transition-property: all;
    transition-property: background-color,border-color;
    width: 20px;
    z-index: 1;
  }
  &.checked {
    &::before {
      background-color: #231f20;
      // border-color: #231F20;
    }
    &::after {
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
      content: "";
      height: 12px;
      left: 8px;
      position: absolute;
      right: unset;
      top: 6px;
      transform: rotate(45deg);
      transition: border-color .28s cubic-bezier(.4,0,.2,1);
      width: 6px;
      z-index: 2;
    }
  }
}
</style>
